module.exports = __webpack_public_path__ + "static/img/11.cb75996.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/11.png
// module id = 8QXa
// module chunks = 0